package it.unibo.tuprolog.parser.exceptions

/** Stable programmatic categories for [PrologSyntaxException] diagnostics. */
enum class SyntaxErrorCode {
    UNEXPECTED_CHARACTER,
    UNTERMINATED_QUOTED_LITERAL,
    UNTERMINATED_BLOCK_COMMENT,
    INVALID_ESCAPE,
    MALFORMED_NUMERIC_LITERAL,
    UNEXPECTED_TOKEN,
    UNEXPECTED_END_OF_INPUT,
    MISSING_OPERATOR_OPERAND,
    OPERATOR_PRIORITY_VIOLATION,
    AMBIGUOUS_OPERATOR_USE,
    MISSING_CLAUSE_TERMINATOR,
    NESTING_LIMIT_EXCEEDED,
    SOURCE_READ_FAILURE,
    TOKEN_BUFFER_LIMIT_EXCEEDED,
}
